export default __webpack_public_path__ + "static/media/029-grill.bb52e944.svg";